import React from 'react';
import { useSearchParameter } from 'framework/routing';
import useIdentityService from './identityService';
import { DefaultTokenProvider, useTokenProvider } from 'infrastructure/security/authentication/DefaultTokenProvider';

const UrlTokenProvider = ({ children }: { children: React.ReactNode }) => {
  const token = useSearchParameter('token');
  const { getToken: parentGetToken } = useTokenProvider();

  const { exchangeToken } = useIdentityService();
  const getToken = !token ? parentGetToken : () => exchangeToken(token);

  return <DefaultTokenProvider getToken={getToken}>{children}</DefaultTokenProvider>;
};

export default UrlTokenProvider;
